import { makeAutoObservable, runInAction } from 'mobx';
import ChatStore from '@/store/chat/ChatStore';
import { request } from '@/common';
import { HelperCore } from '@/common/dependencies';
import Conf from '@/common/conf';
import slsLogger from '@public/log/sls';
import knowledgeModelSelectStore from './components/knowledege-model-select/store';

class Store {
  chatStore = null;
  stores = {};
  emptyKnowledges = {};

  constructor () {
    makeAutoObservable(this);

    if(!HelperCore.IS_PROD){
      window._chatKnowledgeStore = this;
    }
  }

  updateChatStore (knowledgeId, knowledgeksId) {
    // if(!knowledgeId || this.stores[knowledgeId]){
    //   this.createNewChatStore(knowledgeId);
    //   return;
    // }

    if(!knowledgeId){
      return;
    }

    // 从服务端获取知识库对应的 cid
    request.get("/knowledge/last_conversation", {
      params : {
        knowledge_id : knowledgeId,
        dataset_src : "1",
      },
    })
    .then(res => {
      slsLogger.log({
        key : "knowledge",
        action : "last_conversation",
        ext : JSON.stringify(res),
        ext2 : knowledgeId,
      });

      const { data } = res;
      const {
        conversation_id,
        role,
      } = data;

      // 必须是可选的模型
      if(!knowledgeModelSelectStore.supportRole(role)){
        throw new Error('不支持的模型');
      }

      runInAction(() => {
        let chatStore = Object.values(this.stores).find(store => store.chatId == conversation_id);
        if(!chatStore){
          chatStore = new ChatStore({ id: conversation_id, asstId : role });
          chatStore.fetchChatHistory(conversation_id);
        }
        this.chatStore = chatStore;
        this.stores[knowledgeId] = this.chatStore;


        HelperCore.log("updateChatStore", this.chatStore.currAsstId);
      });
    })
    .catch(() => {
      this.createNewChatStore(knowledgeId, knowledgeksId);
    })
  }

  createNewChatStore (knowledgeId, knowledgeksId, forceNewChat) {
    if(this.stores[knowledgeId] && !forceNewChat){
      this.chatStore = this.stores[knowledgeId];
      return;
    }

    if(!knowledgeModelSelectStore.curId || !knowledgeModelSelectStore.curId.includes("_")){
      this.chatStore = new ChatStore({ asstId : knowledgeModelSelectStore.curId || Conf.roleIds.knowledge });
    }
    else {
      const [roleId, knModelId] = knowledgeModelSelectStore.curId.split("_");
      const knModel = knowledgeModelSelectStore.list.find(item => item.kn_custom_model?.id == knModelId).kn_custom_model;
      this.chatStore = new ChatStore({ asstId : roleId, knModel });
    }
    this.stores[knowledgeId] = this.chatStore;
    this.emptyKnowledges[knowledgeId] = true;
    HelperCore.log("createNewChatStore", this.chatStore.currAsstId);
  }

  setEmptyKnowledges (data) {
    this.emptyKnowledges = {
      ...this.emptyKnowledges,
      ...data,
    }
  }
}

const chatKnowledgeStore = new Store();
export default chatKnowledgeStore;